import React, { ButtonHTMLAttributes, FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import classes from './button.module.scss';
import Loader from 'components/Loader';

type Props = {
  isLoading?: boolean;
  loaderClassName?: string;
};

const OnahButton: FC<PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement> & Props>> = ({children, loaderClassName, ...props}) => {
  const {className, disabled, isLoading, ...buttonProps} = props;
  return (
    <button 
      {...buttonProps}
      disabled={disabled || isLoading}
      className={classNames(className, classes.btn, (disabled || isLoading) ? classes.btn__inactive : '')}
    >{isLoading ? <Loader className={classNames(classes.btn__Loader, loaderClassName)}/> : children}</button>
  )
}

export default OnahButton;